// ***************************************
// Definition of game token PlayController
// ***************************************
import { levelRandomiser, gameController, inventoryController, profileManager, _cheatsEnabled, customMessagecontroller, leaderboardManager, instantNotificationsService, flowController } from "../../game_theme/flow_fb/flowController";
import { tbGame } from "../engine/tbGame";
import { tgfHooks } from "../framework/hooks/hooks";
import { tbKeyCodes } from "../framework/tbKeyCodes";
import { tgfAudio } from "../framework/tgfAudio";
import { tgfDictionary } from "../framework/tgfDictionary";
import { tgfGraphics } from "../framework/tgfGraphics";
import { tgfSettings } from "../framework/tgfSettings";
import { AIFakeRandomSettings, AISettings, PowerUpSettings, CustomUpdateSettings, LevelSettings } from "../settings/Settings";
import { SoundManager } from "../settings/SoundManager";
import { AIController } from "./AIController";
import { AngryAnalytics } from "./Analytics/Analytics";
import { AngryOptionScreenDialog } from "./AngryOptionScreenDialog";
import { uncompressData } from "./Compression";
import { EndScreen } from "./EndScreen";
import { ExpManager } from "./ExpManager";
import { floater } from "./Floater";
import { FriendManager } from "./FriendManager";
import { UIController } from "./GameUI/UIController";
import { AngryTutorial } from "./LobbyCode/AngryTutorialDialog";
import { LoadingOverlay } from "./LobbyCode/LoadingOverlay";
import { MightyScopeDialog } from "./LobbyCode/MightyScopeDialog";
import { PowerupRefillDialog } from "./LobbyCode/PowerupRefillDialog";
import { MessagerDialog } from "./MessagerDialog";
import { NudgeFactory } from "./NudgeFactory";
import { ReplayController } from "./ReplayController";
import { ReplayData } from "./ReplayData";
import { ReplayTransitionToken } from "./ReplayTransitionToken";
import { SceneBuilder } from "./SceneBuilder";
import { SceneController, SceneControllerState } from "./SceneController";
import { SkipReplayAnimation } from "./SkipReplayAnimation";
import { WaitingScreen } from "./WaitingScreen";
import { playController } from "./gameController";
import { YoutubeStorageManager } from "./storage/YoutubeStorageManager";
// The constructor for the PlayController game token. 
export var PlayController = function (lobbyData, isRandomOpponent, isAI, isFake) {
    "use strict";
    // Properties used by the engine
    this.layer = 0;
    this.visible = true;
    this.active = true;
    // Your own properties
    this.uiHidden = false;
    this.powerupsVisible = false;
    this.isShooting = false;
    this.isMirrored = false;
    this.isSelectingBird = false;
    this.infiniteBirds = false;
    this.waitingForPlayerWithoutDialog = false;
    this.tutorialDialog = null;
    this.sceneControllerActivePopUps = false;
    this.sharedData = null;
    this.lobbyData = lobbyData;
    this.isRandomOpponent = isRandomOpponent;
    this.isAI = isAI;
    this.isFake = isFake;
    this.bothPlayersSawTheEndscreen = false;
    this.isInitiatingPlayer = false;
    this.waitingForOtherPlayersMove = false;
    this.matchId = -1;
    this._showReplay = true;
    this.levelIndex = -1;
    if (this.isAI && this.isFake) {
        this.gameType = "random";
        AngryAnalytics.reportScreen("random");
    }
    else if (this.isAI) {
        this.gameType = "practice";
        AngryAnalytics.reportScreen("practice");
    }
    else {
        this.gameType = "challenge";
        AngryAnalytics.reportScreen("challenge");
    }
    this.inputEnabled = true;
    this.isIngame = true;
};
PlayController.GetInitialMatchData = function (isRandom, limitedLevels) {
    var levelIndex = levelRandomiser.SelectRandomLevel(limitedLevels);
    if (playController) {
        playController.levelIndex = levelIndex;
    }
    var initialData = {
        "data": {
            "initiatingPlayer": tgfHooks.getPlayerID(),
            "roundNumber": 0,
            "seed": Math.floor(Math.random() * 1e10),
            "otherPlayerData": {
                "id": "",
                "score": 0
            },
            "initiatingPlayerData": {
                "name": tgfHooks.getPlayerName(),
                "img": tgfHooks.getPlayerImageUrl(),
                "id": tgfHooks.getPlayerID(),
                "score": 0
            }
        },
        "levelSettings": {
            "levelIndex": levelIndex
        }
    };
    if (isRandom) {
        initialData["lobby"] = {
            "state": "",
            "matchID": "",
            "context": "",
            "watchedFinalReplay": "",
            "isRandomOpponent": "",
            "isAI": "",
            "lastTurnID": "",
            "initiatingPlayerData": "",
            "otherPlayerData": "",
            "levelVersion": "",
        };
    }
    return initialData;
};
// handleAdd is called when the token is (re-) added to the game. 
PlayController.prototype.handleAdd = function () {
    "use strict";
    var self = this;
    if (this.isAI) {
        var settings = this.isFake ? AIFakeRandomSettings : AISettings;
        AIController.createMatch(settings, this.isFake, function (id, data) {
            self.matchId = id;
            self.sharedData = data["data"];
            self.levelIndex = data["levelSettings"]["levelIndex"];
            self.isInitiatingPlayer = true;
            self.waitingForOtherPlayersMove = false;
            AngryAnalytics.reportLobbyEntry(true, self.levelIndex, self.matchId);
            AngryAnalytics.reportStartGame("new");
            self.addGame();
        });
    }
    else {
        this.initMultiplayer();
    }
};
PlayController.prototype.addGame = function () {
    var self = this;
    console.log("Game Added");
    if (this.isInitiatingPlayer) {
        this.isMirrored = false;
    }
    else {
        this.isMirrored = true;
    }
    this.sceneController = new SceneController(0, 0, -1, this.levelIndex);
    floater.initFloaterPool();
    this.sceneBuilder = new SceneBuilder(this.levelIndex);
    this.uiController = new UIController(this.openSettingsDialog.bind(this), this.onLobbyButtonPressed.bind(this), this.sceneController.countPigs.bind(this.sceneController), this.sceneController.canSwapPigs.bind(this.sceneController), this.sceneController.isPlacingPowerup.bind(this.sceneController), function () { return self.sharedData; }, function () { return self.isShooting; }, function () { return self.waitingForPlayerWithoutDialog; }, function () { return !!self.waitingScreen; });
    tgfAudio.stop("music");
    tgfAudio.stop("ambience");
    SoundManager.playEffect(SoundManager.MUSIC_STATE.GAME, SoundManager.MusicCollection, 0, true);
    SoundManager.playEffect(SoundManager.MUSIC_STATE.AMBIENCE, SoundManager.MusicCollection, 0, true);
    this.messageHandler = new MessagerDialog({
        x: tgfGraphics.areaWidth / 2,
        y: tgfGraphics.areaHeight / 2
    });
    this.messageHandler.show();
    if (!this.sharedData["uncompressed"] && this.sharedData["blocks"] && this.sharedData["replay"]) {
        this.sharedData["blocks"] = uncompressData(this.sharedData["blocks"]);
        this.sharedData["replay"] = ReplayData.getUncompressedData(this.sharedData["replay"]);
        this.sharedData["uncompressed"] = true;
    }
    this.sceneController.handleEntryData(this.sharedData);
    this.initUi();
    this.updatePlayerData();
    this.bothPlayersSawTheEndscreen = false;
};
PlayController.prototype.handleFirstTutorial = function (onClose) {
    "use strict";
    var self = this;
    // We return abruptly here since the player will be kicked to lobby anyway, and it
    // saves us all the UI bugs
    if (flowController.isOffline) {
        return;
    }
    YoutubeStorageManager.getPlayerData(["hasSeenTutorial"], function (data) {
        if (!data["hasSeenTutorial"]) {
            AngryAnalytics.reportOnBoardingTime("start", 0);
            self.onBoardingTimeStart = Date.now();
            YoutubeStorageManager.savePlayerData(["hasSeenTutorial"], [true], function () {
                console.log("saved first tutorial viewing");
            }, function (error) {
                console.log(error);
            });
            var dialog;
            dialog = new AngryTutorial({
                darken: true,
                onHide: function () {
                    AngryAnalytics.reportOnBoardingTime("end", Date.now() - self.onBoardingTimeStart);
                    self.sceneControllerActivePopUps = false;
                    self.tutorialDialog = null;
                    if (onClose) {
                        onClose();
                    }
                },
                delayClose: false,
                x: tgfGraphics.areaWidth / 2,
                y: tgfGraphics.areaHeight / 2,
            });
            self.sceneControllerActivePopUps = true;
            dialog.show();
            self.tutorialDialog = dialog;
        }
        else if (onClose) {
            onClose();
        }
    });
};
PlayController.prototype.handlePowerupRefillDialog = function (onClose) {
    if (!this.isAI || this.isFake) {
        if (gameController.mightyScopeEnd < Date.now() && gameController.mightyScopeDialogEnabled && tgfHooks.areAdsSupported()) {
            var mightyScopeDialog = new MightyScopeDialog({
                onClose: onClose
            });
            mightyScopeDialog.show();
        }
        else if (inventoryController.getFilledPowerUps() < PowerUpSettings.maxSlotAmount && tgfHooks.areAdsSupported()) {
            var refillDialog = new PowerupRefillDialog({
                onClose: onClose
            });
            refillDialog.show();
        }
        else if (onClose) {
            onClose();
        }
    }
    else if (onClose) {
        onClose();
    }
};
PlayController.prototype.removeGame = function () {
    "use strict";
    console.log("Game Removing");
    if (this.uiController) {
        this.uiController.freeUI();
    }
    if (this.fps)
        tbGame.removeToken(this.fpsCounter);
    if (this.sceneBuilder)
        tbGame.removeToken(this.sceneBuilder);
    if (this.sceneController)
        tbGame.removeToken(this.sceneController);
    if (this.messageHandler) {
        this.messageHandler.hide();
        this.messageHandler.free();
    }
    if (this.waitingScreen) {
        tbGame.removeToken(this.waitingScreen);
    }
    if (this.endScreen) {
        tbGame.removeToken(this.endScreen);
    }
    floater.cleanFloaters();
    this.fps = null;
    this.sceneController = null;
    this.messageHandler = null;
    this.waitingScreen = null;
    this.endScreen = null;
    console.log("Game Removed");
};
// handleRemove is called when the token is removed from the game.
PlayController.prototype.handleRemove = function () {
    "use strict";
    this.removeGame();
};
PlayController.prototype.reinitializePowerUpUI = function () {
    "use strict";
    this.sceneController.canUsePowerUp = true;
    this.uiController.reinitializePowerUpUI();
};
PlayController.prototype.loadedOpponent = function (type) {
    var id;
    switch (type) {
        case "initial":
            id = this.sharedData["initiatingPlayerData"]["id"];
            break;
        case "opponent":
            id = this.sharedData["otherPlayerData"]["id"];
            break;
    }
    this.opponentData = profileManager.getInfo(id);
    this.uiController.loadedOpponent(this.opponentData, id);
};
PlayController.prototype.getOpponentId = function () {
    if (this.contextPlayer.getID) {
        return this.contextPlayer.getID();
    }
    else {
        return this.contextPlayer;
    }
};
PlayController.prototype.initUi = function () {
    var self = this;
    this.sharedData = this.sceneController.entryData;
    if (!this.sharedData["otherPlayerData"]["id"] && this.lobbyData["otherPlayerData"]) {
        this.sharedData["otherPlayerData"]["id"] = this.lobbyData["otherPlayerData"]["id"];
        this.sharedData["otherPlayerData"]["img"] = this.lobbyData["otherPlayerData"]["img"];
        this.sharedData["otherPlayerData"]["name"] = this.lobbyData["otherPlayerData"]["name"];
    }
    if (this.isInitiatingPlayer && this.sharedData["roundNumber"] <= 0 && this.isRandomOpponent) {
        var _opponent = this.lobbyData["otherPlayerData"];
        if (profileManager.checkIfComplete(_opponent.id) == false) {
            profileManager.doneCallback = function () {
                self.loadedOpponent("opponent");
            };
            profileManager.loadImage(_opponent.id, _opponent.img);
            profileManager.setName(_opponent.id, _opponent.name);
        }
        else {
            this.loadedOpponent("opponent");
        }
    }
    // In random matches the context is not switched and is invalid
    if (this.isInitiatingPlayer && this.sharedData["roundNumber"] <= 0 && !this.isRandomOpponent && !this.isAI) {
        var _opponent = this.contextPlayer;
        if (_opponent) {
            self.sharedData["otherPlayerData"]["name"] = _opponent.getName();
            self.sharedData["otherPlayerData"]["id"] = _opponent.getID();
            self.sharedData["otherPlayerData"]["img"] = _opponent.getPhoto();
            _opponent = self.sharedData["otherPlayerData"];
            if (profileManager.checkIfComplete(_opponent.id) == false) {
                profileManager.doneCallback = function () {
                    self.loadedOpponent("opponent");
                };
                profileManager.loadImage(_opponent.id, _opponent.img);
                profileManager.setName(_opponent.id, _opponent.name);
            }
            else {
                self.loadedOpponent("opponent");
            }
        }
    }
    this.uiController.initUI(this.isInitiatingPlayer);
};
PlayController.prototype.updatePlayerData = function () {
    var self = this;
    this.opponentData = profileManager.getInfo();
    if (this.sharedData && this.sharedData["initiatingPlayer"] !== tgfHooks.getPlayerID()) {
        if (!profileManager.exists(this.sharedData["initiatingPlayerData"]["id"])) {
            var _data = {
                "initiatingPlayerData": this.sharedData["initiatingPlayerData"]
            };
            profileManager.threadLoader(_data, function () {
                self.loadedOpponent("initial");
            });
        }
        else {
            self.loadedOpponent("initial");
        }
    }
    else if (this.sharedData && this.sharedData["otherPlayerData"]["id"] !== "") {
        if (!profileManager.exists(this.sharedData["otherPlayerData"]["id"])) {
            var _data = {
                "otherPlayerData": this.sharedData["otherPlayerData"]
            };
            profileManager.threadLoader(_data, function () {
                self.loadedOpponent("opponent");
            });
        }
        else {
            self.loadedOpponent("opponent");
        }
    }
};
PlayController.prototype.updateUI = function (updateEverything) {
    "use strict";
    if (updateEverything) {
        this.updatePlayerData();
    }
    this.uiController.updateUI(this.isInitiatingPlayer);
};
// handleBeginStep is called each step before processing other events.
PlayController.prototype.handleBeginStep = function (timePassed) {
    "use strict";
};
// handleTouchDown is called when a touch is started or if a mouse button is pressed.
PlayController.prototype.handleTouchDown = function (finger, x, y) {
    "use strict";
};
// handleTouchUp is called when a touch is ended or if a mouse button is released.
PlayController.prototype.handleTouchUp = function (finger, x, y) {
    "use strict";
};
// handleKeyUp is called if the key with the given keyCode is released.
PlayController.prototype.handleKeyUp = function (keyCode) {
    "use strict";
    if (!_cheatsEnabled) {
        return;
    }
    // press j to toggle ui
    if (keyCode == tbKeyCodes.vkJ)
        this.uiHidden = !this.uiHidden;
    // press m to toggle mirrored mode
    if (keyCode == tbKeyCodes.vkM)
        this.isMirrored = !this.isMirrored;
    // Press R to show the current replay
    if (keyCode == tbKeyCodes.vkR) {
        console.log("starting replay...");
        this.showReplay();
    }
    if (keyCode == tbKeyCodes.vkS) {
        //console.log(JSON.stringify(this.sharedData));
        this.infiniteBirds = !this.infiniteBirds;
        if (this.infiniteBirds) {
            this.uiController.uiCards.cards = ["RedBird", "BlueBird", "YellowBird", "BlackBird"];
            this.uiController.uiCards.selectedCard = 0;
            this.uiController.uiCards.reAddCardUi();
        }
    }
    if (keyCode === tbKeyCodes.vkG) {
        this.sharedData["initiatingPlayerData"]["won"] = true;
        this.sharedData["otherPlayerData"]["won"] = false;
        this.showGameOver(true);
    }
    if (keyCode === tbKeyCodes.vkH) {
        this.sharedData["initiatingPlayerData"]["won"] = false;
        this.sharedData["otherPlayerData"]["won"] = true;
        this.showGameOver(true);
    }
};
// handleAlarm is called if a global alarm is reached.
PlayController.prototype.handleAlarm = function (alarm) {
    "use strict";
};
// handleSpecial is called if a special or user-defined event happens.
PlayController.prototype.handleSpecial = function (id, args) {
    "use strict";
};
PlayController.prototype.saveAndExit = function (en) {
    var self = this;
    //customDebugMessage("(: fps " + this.fpsCounter.getAverageFPSAndLows(0.01).join(", "));
    if (this.isAI) {
        this.sharedData = en;
        this.sharedData["url"] = this.matchId;
        this.sharedData["matchID"] = this.matchId;
        if (this.sharedData["isGameOver"]) {
            this.sharedData["lastTurnID"] = flowController.playerID;
            this.saveMatchData(false, "GAMEOVER");
            this.showGameOver(true);
        }
        else {
            AngryAnalytics.reportEndedTurn(this.matchId);
            this.toggleInput(false);
            AIController.startTurn(function (newData) {
                self.sharedData = newData;
                AngryAnalytics.reportEndedTurn(self.matchId);
                self.toggleInput(true);
            }, function (newData) {
                self.sharedData = newData;
                self.toggleInput(true);
                self.sharedData["lastTurnID"] = newData["otherPlayerData"]["id"];
                self.saveMatchData(false, "GAMEOVER");
                self.showGameOver(true);
            });
        }
        return;
    }
    this.sharedData = en;
    this.sharedData["url"] = this.matchId;
    this.sharedData["matchID"] = this.matchId;
    this.sharedData["context"] = tgfHooks.getContextID();
    this.sharedData["lastTurnID"] = flowController.playerID;
    var wasFirstTurn = false;
    if (!this.sharedData["isGameOver"]) {
        AngryAnalytics.reportEndedTurn(this.matchId);
    }
    this.sharedData["roundNumber"]++;
    if (this.sharedData["roundNumber"] === 1) {
        wasFirstTurn = true;
        this.saveMatchData(true, "PLAY");
        this.turnNotification(true);
        this.waitingForOtherPlayersMove = true;
    }
    else {
        this.saveMatchData(true, "PLAY");
        this.waitingForOtherPlayersMove = true;
        this.turnNotification(false, this.sharedData["isGameOver"]);
    }
    if (this.sharedData["isGameOver"]) {
        this.showGameOver(this.isInitiatingPlayer);
    }
    else {
        this.showWait(wasFirstTurn);
    }
};
PlayController.prototype.turnNotification = function (isInvite, isGameOver) {
    "use strict";
    var self = this;
    if (this.isRandomOpponent || this.isAI) {
        return;
    }
    var nextPlayerId = this.isInitiatingPlayer ? this.sharedData["otherPlayerData"]["id"] : this.sharedData["initiatingPlayerData"]["id"];
    gameController.scheduleMatchNotifications(this.matchId, nextPlayerId);
    if (isInvite && tgfHooks.updateAsync) {
        var inviteMsg = NudgeFactory.GetPremadeNudge('update', 2, {});
        var tag = customMessagecontroller.getInviteTag();
        var inviteIndex = customMessagecontroller.getMessageIndex();
        customMessagecontroller.saveIndex();
        var localizations = NudgeFactory.GenerateCustomUpdateLocalization(CustomUpdateSettings.inviteMessage[inviteIndex], [
            tgfHooks.getPlayerName()
        ]);
        var CTAlocalizations = NudgeFactory.GenerateCustomUpdateLocalization(CustomUpdateSettings.inviteCTA[inviteIndex]);
        tgfHooks.updateAsync(function () {
            AngryAnalytics.reportAutomatedCustomMessages(true, tag);
        }, tag, inviteMsg, CTAlocalizations, localizations, { "id": this.matchId, "round": this.sharedData.roundNumber, "tag": tag });
    }
    else if (isGameOver) {
        this.winData = null;
        this.loseData = null;
        var initialPlayerWon = false;
        if (this.isInitiatingPlayer && this.sharedData["initiatingPlayerData"]["won"]) {
            initialPlayerWon = true;
        }
        else if (!this.isInitiatingPlayer && !this.sharedData["initiatingPlayerData"]["won"]) {
            initialPlayerWon = true;
        }
        if (initialPlayerWon) {
            this.winData = this.isInitiatingPlayer ? playController.sharedData["initiatingPlayerData"] : playController.sharedData["otherPlayerData"];
            this.loseData = this.isInitiatingPlayer ? playController.sharedData["otherPlayerData"] : playController.sharedData["initiatingPlayerData"];
        }
        else {
            this.winData = this.isInitiatingPlayer ? playController.sharedData["otherPlayerData"] : playController.sharedData["initiatingPlayerData"];
            this.loseData = this.isInitiatingPlayer ? playController.sharedData["initiatingPlayerData"] : playController.sharedData["otherPlayerData"];
        }
        var winnerFirstName = profileManager.getFirstName(this.winData["id"]);
        var loserFirstName = profileManager.getFirstName(this.loseData["id"]);
        var endMsg = NudgeFactory.GetPremadeNudge("share", Math.ceil(2 * Math.random()), {
            winData: this.winData,
            loseData: this.loseData,
            winnerFirstName: winnerFirstName,
            loserFirstName: loserFirstName,
            canAddScore: playController.canAddScoreToLeaderboard()
        });
        var localizations = NudgeFactory.GenerateCustomUpdateLocalization(CustomUpdateSettings.endMessage, [
            winnerFirstName,
            loserFirstName
        ]);
        var CTAlocalizations = NudgeFactory.GenerateCustomUpdateLocalization(CustomUpdateSettings.endCTA);
        tgfHooks.updateAsync(function () {
            AngryAnalytics.reportAutomatedCustomMessages(false);
        }, "end_turn", endMsg, CTAlocalizations, localizations, { id: this.matchId, round: this.sharedData.roundNumber, "tag": "turn" });
    }
    else {
        var turnMsg = NudgeFactory.GetPremadeNudge('update', 1, {});
        if (tgfHooks.updateAsync) {
            var rand = Math.floor(Math.random() * CustomUpdateSettings.turnMessages.length);
            var randomMessage = CustomUpdateSettings.turnMessages[rand];
            var localizations = NudgeFactory.GenerateCustomUpdateLocalization(randomMessage, [
                playController.opponentData.name
            ]);
            var CTAlocalizations = NudgeFactory.GenerateCustomUpdateLocalization(CustomUpdateSettings.turnCTA[rand]);
            tgfHooks.updateAsync(function () {
                AngryAnalytics.reportAutomatedCustomMessages(false);
            }, "turn", turnMsg, CTAlocalizations, localizations, { id: this.matchId, round: this.sharedData.roundNumber, "tag": "turn" });
        }
    }
};
PlayController.prototype.showGameOver = function (isInitPlayer) {
    "use strict";
    if (flowController.isOffline) {
        return;
    }
    var initialPlayerWon = false;
    if (typeof (isInitPlayer) !== 'undefined') {
        this.isInitiatingPlayer = isInitPlayer;
    }
    if (this.isInitiatingPlayer && this.sharedData["initiatingPlayerData"]["won"]) {
        initialPlayerWon = true;
        if (this.canAddScoreToLeaderboard()) {
            leaderboardManager.sendScore(this.sharedData["initiatingPlayerData"]["totalPigs"]);
        }
    }
    else if (!this.isInitiatingPlayer && !this.sharedData["initiatingPlayerData"]["won"]) {
        initialPlayerWon = true;
        if (this.canAddScoreToLeaderboard()) {
            leaderboardManager.sendScore(this.sharedData["otherPlayerData"]["totalPigs"]);
        }
    }
    if (this.isInitiatingPlayer) {
        FriendManager.addPlayerIdToHistory(this.sharedData["otherPlayerData"]["id"]);
    }
    else {
        FriendManager.addPlayerIdToHistory(this.sharedData["initiatingPlayerData"]["id"]);
    }
    AngryAnalytics.reportGameStatus(initialPlayerWon, ExpManager.getRank());
    if (this.optionScreen) {
        this.optionScreen.hide();
        this.optionScreen.free();
        this.optionScreen = null;
    }
    this.bothPlayersSawTheEndscreen = this.sharedData["watchedFinalReplay"] >= 1;
    if (this.bothPlayersSawTheEndscreen) {
        instantNotificationsService.removeMatchNotification(this.matchId);
    }
    this.endScreen = new EndScreen({ playerData: this.sharedData["initiatingPlayerData"], opponentData: this.sharedData["otherPlayerData"] }, this.isInitiatingPlayer ? true : false, initialPlayerWon);
    this.endScreen.setCallback(function () {
        if (!this.canRematch()) {
            console.error("Invalid rematch. Something went wrong.");
        }
        if (this.isAI && this.isFake) {
            // start a new fake random match
            gameController.startPlay({}, null, false, true, true, this.sharedData);
        }
        else {
            // start a new game with the same player
            var playerData = this.isInitiatingPlayer ? { "otherPlayerData": this.sharedData["otherPlayerData"] } : { "initiatingPlayerData": this.sharedData["initiatingPlayerData"] };
            gameController.startPlay(playerData, tgfHooks.getContextID(), false, false, false, this.sharedData);
        }
    }, this);
};
PlayController.prototype.showWait = function (wasFirstTurn) {
    "use strict";
    if (flowController.isOffline) {
        return;
    }
    if (this.isInitiatingPlayer && wasFirstTurn) {
        levelRandomiser.AddLevelToPlayHistory(this.levelIndex);
    }
    this.sceneController.usedPowerupThisTurn = false;
    this.waitingScreen = new WaitingScreen();
};
PlayController.prototype.showPowerupBar = function () {
    "use strict";
    this.uiController.showPowerupBar();
};
PlayController.prototype.hidePowerupBar = function () {
    "use strict";
    this.uiController.hidePowerupBar();
};
PlayController.prototype.handleEndStep = function (timePassed) {
    "use strict";
    this.handleUIMovement(timePassed);
    SoundManager.checkForLoadedSounds();
};
PlayController.prototype.handleUIMovement = function (timePassed) {
    "use strict";
    if (this.uiController) {
        var uiHidden = (this.isShooting
            || this.sceneController.state === SceneControllerState.POWERUP_AVAILABLE
            || this.sceneController.state === SceneControllerState.POWERUP_APPLYING
            || this.sceneController.state === SceneControllerState.GAME_WORKING
            || this.sceneController.state === SceneControllerState.TURN_STARTED
            || this.uiHidden);
        this.uiController.handleUIMovement(timePassed, uiHidden);
    }
};
// handleDraw is called at the end of a step to draw the token.
PlayController.prototype.handleDraw = function () {
    "use strict";
};
PlayController.prototype.initMultiplayer = function () {
    "use strict";
    var entryData = null;
    var self = this;
    if (this.lobbyData) {
        entryData = this.lobbyData;
        entryData.id = this.lobbyData["url"];
    }
    var listener = {
        triggered: false,
        connected: function (source) {
            self.onConnected();
        },
        unstableConnectionStarted: function (source) { },
        connectionNormalized: function (source) { },
        disconnected: function (source) { },
        messageReceived: function (msg, source) {
            self.onMessage(msg);
        }
    };
    if (!entryData || !entryData.id) {
        this.isInitiatingPlayer = true;
        var shouldReportLobbyEntry = !!flowController.lobbyScreenDialog;
        tgfHooks.getContextPlayers(function (players) {
            var _opponent = null, opponents = [];
            for (var i = 0; i < players.length; i++) {
                if (players[i].getID() == tgfHooks.getPlayerID()) {
                    // its the player! ignore
                }
                else {
                    // opponent
                    _opponent = players[i];
                    break;
                }
            }
            if (_opponent) {
                self.contextPlayer = _opponent;
                opponents.push(_opponent.getID());
            }
            // randomizing the level before starting the match
            // gamesBackendService.createMatch(opponents, PlayController.GetInitialMatchData(false),
            //     function (matchId, data) {
            //         self.matchId = matchId;
            //         self.room = gamesBackendService.enterRoom(matchId, listener);
            //         if (shouldReportLobbyEntry) {
            //             AngryAnalytics.reportLobbyEntry(true, self.levelIndex, self.matchId);
            //         }
            //     },
            //     function (error) {
            //         //customDebugMessage("Failed to create match");
            //     },
            //     tgfHooks.getContextID()
            // );
        }, function (error) {
            console.log(error);
        });
    }
    else {
        this.matchId = entryData.id;
        // gamesBackendService.joinMatch(self.matchId,
        //     function () {
        //         self.room = gamesBackendService.enterRoom(self.matchId, listener);
        //     },
        //     function (error) {
        //         self.room = gamesBackendService.enterRoom(self.matchId, listener);
        //     }
        // );
    }
};
PlayController.prototype.isNewGame = function () {
    "use strict";
    var isNew = false;
    if (this.isRandomOpponent && this.lobbyData && this.lobbyData["id"] && this.lobbyData["roundNumber"] && this.lobbyData["roundNumber"] < 0) {
        isNew = true;
    }
    else if (!this.isRandomOpponent && this.lobbyData && !this.lobbyData["id"]) {
        isNew = true;
    }
    return isNew;
};
PlayController.prototype.saveMatchData = function (notifyOpponent, lobbyState) {
    "use strict";
    var self = this;
    var lobby = {
        "state": lobbyState,
        "matchID": this.matchId,
        "context": (this.isRandomOpponent || this.isAI) ? 0 : tgfHooks.getContextID(),
        "watchedFinalReplay": this.sharedData["watchedFinalReplay"],
        "isRandomOpponent": this.isRandomOpponent,
        "isAI": this.isAI,
        "lastTurnID": flowController.playerID,
        "initiatingPlayerData": this.sharedData["initiatingPlayerData"],
        "otherPlayerData": this.sharedData["otherPlayerData"],
        "levelVersion": LevelSettings.levelList[this.levelIndex].levelExtra.version,
    };
    if (this.sharedData && this.sharedData["roundNumber"] === 1) {
        lobby["timestamp"] = inventoryController ? inventoryController.serverTime : Date.now();
    }
    if (!this.isAI) {
        this.room.saveMatchData(["data", "lobby"], [this.sharedData, lobby], function () {
            if (notifyOpponent) {
                self.room.sendMessage({ "event": "end_turn" });
            }
        }, function (error) {
            console.error("saveMatchData failed (error: " + error + ")");
        }, tgfSettings.matchTurnExpirationTime);
    }
    else {
        AIController.updateMatchData(this.matchId, this.sharedData["initiatingPlayerData"]["won"], function () {
            // 
        });
    }
};
PlayController.prototype.onConnected = function () {
    "use strict";
    var self = this;
    this.room.getMatchData(["data", "levelSettings"], function (data) {
        if (!data["levelSettings"]) {
            throw new Error("Couldn't get level data from match");
        }
        self.levelIndex = data["levelSettings"]["levelIndex"];
        self.sharedData = data["data"];
        if (!self.contextPlayer) {
            if (self.sharedData.otherPlayerData.id == tgfHooks.getPlayerID()) {
                self.contextPlayer = self.sharedData.initiatingPlayerData.id;
            }
            else {
                self.contextPlayer = self.sharedData.otherPlayerData.id;
            }
        }
        AngryAnalytics.reportStartGame(self.isNewGame() ? 'new' : 'continue' // QBB-1271
        );
        self.isInitiatingPlayer = self.sharedData["initiatingPlayer"] === tgfHooks.getPlayerID() ? true : false;
        var hasLevelData = self.sharedData["blocks"];
        if (!hasLevelData) {
            // lastTurnID is used to know whose turn it is
            var initiatingPlayerID = self.sharedData["initiatingPlayer"];
            if (initiatingPlayerID && (initiatingPlayerID != flowController.playerID)) {
                self.sharedData["lastTurnID"] = flowController.playerID;
            }
            self.waitingForOtherPlayersMove = !self.isInitiatingPlayer;
            self.addGame();
            if (self.waitingForOtherPlayersMove) {
                self.showWait();
            }
        }
        else {
            self.waitingForOtherPlayersMove = true;
            if (!self.sceneController) {
                self.addGame();
            }
            self.processData(data["data"]);
        }
    });
};
PlayController.prototype.onMessage = function (msg) {
    var self = this;
    if (msg["event"] === "end_turn") {
        this.room.getMatchData(["data"], function (data) {
            // handle gacha
            self.processData(data["data"]);
        }, function (error) {
            // TODO -- handle error here?
        });
    }
};
PlayController.prototype.processData = function (data) {
    "use strict";
    var self = this;
    if (!this.sceneController) {
        // we aren't ingame, we can safely return
        return;
    }
    var canCloseDialog = false;
    var activeDialog = null;
    if (this.optionScreen) {
        activeDialog = this.optionScreen;
        canCloseDialog = true;
    }
    else if (this.tutorialDialog) {
        activeDialog = this.tutorialDialog;
        canCloseDialog = true;
    }
    else {
        if (this.waitingScreen && this.waitingScreen.gachaScreen) {
            activeDialog = this.waitingScreen.gachaScreen;
        }
        else if (this.waitingScreen && this.waitingScreen.waitingForFB === true) {
            // We handle this specially because of FB
            this.waitingScreen.closedAsyncCallback = function () {
                if (self.waitingScreen) {
                    self.waitingScreen.waitingForFB = false;
                }
                self.processData(data);
            };
            return;
        }
        else if (this.waitingScreen && this.waitingScreen.newGameDialogOpen === true) {
            this.waitingScreen.startStoredReplay = function () {
                self.processData(data);
            };
            return;
        }
        else if (this.activeWarningDialog) {
            activeDialog = this.activeWarningDialog;
        }
        else if (this.waitingScreen && this.waitingScreen.waitingForAd) {
            return;
        }
        else if (this.waitingScreen && this.waitingScreen.shortcutDialog) {
            this.waitingScreen.afterShortcutRequest = function () {
                self.processData(data);
            };
            return;
        }
    }
    if (this.chooseContextIsOpen) {
        this.replayQueued = true;
        this.storedReplayData = data;
        return;
    }
    if (activeDialog && !this.replayQueued && canCloseDialog === false) {
        var storedFunc = activeDialog.onClose ? activeDialog.onClose : function () { };
        activeDialog.onClose = function () {
            storedFunc();
            self.replayQueued = false;
            self.processData(data);
        };
        this.replayQueued = true;
        return;
    }
    else if (activeDialog && this.replayQueued === true) {
        return;
    }
    this.sharedData = data;
    if (!this.sharedData["uncompressed"] && this.sharedData["blocks"] && this.sharedData["replay"]) {
        this.sharedData["blocks"] = uncompressData(this.sharedData["blocks"]);
        this.sharedData["replay"] = ReplayData.getUncompressedData(this.sharedData["replay"]);
        this.sharedData["uncompressed"] = true;
    }
    console.log("Round Number: " + this.sharedData["roundNumber"]);
    this.sceneController.populateOpponent();
    if (gameController.transition) {
        // we already played the transition, don't need to again
        gameController.transition = null;
        if (this.waitingScreen) {
            this.waitingScreen.setCallback(this.showReplay, this);
            this.waitingScreen.playEndAnimation();
        }
        else {
            this.showReplay();
        }
    }
    else {
        // we didn't!
        if (self.waitingScreen) {
            self.waitingScreen.inputDisabled = true;
        }
        else if (activeDialog && canCloseDialog === true) {
            activeDialog.disappear();
        }
        self.transition = new ReplayTransitionToken(function () {
            if (self.waitingScreen) {
                self.waitingScreen.destroyAndRemove();
            }
            self.showReplay();
        }, function () {
        });
    }
    this.isShooting = true;
};
PlayController.prototype.showReplay = function () {
    "use strict";
    var self = this;
    this._showReplay = true;
    if (this.optionScreen) {
        this.optionScreen.disappear();
    }
    this.sceneController.disableMightyScope();
    this.replayController = new ReplayController(this.sharedData, function () {
        self.nextPlay();
        self.checkMightyScope();
    }, function () {
        self.skipReplay();
    });
};
PlayController.prototype.checkMightyScope = function () {
    if (Date.now() < gameController.mightyScopeEnd || this.gameType == "practice") {
        this.sceneController.enableMightyScope();
    }
    else {
        this.sceneController.disableMightyScope();
    }
};
PlayController.prototype.nextPlay = function () {
    "use strict";
    if (this.initGameOver() || !this.sceneController) {
        return;
    }
    var self = this;
    if (self.waitingForOtherPlayersMove) {
        self.isShooting = false;
        self.waitingForOtherPlayersMove = false;
        this.reinitializePowerUpUI();
        this.sceneController.afterReplay(this.sharedData);
        this.updateUI(true);
    }
    else {
        console.log("Should never get here");
    }
};
PlayController.prototype.skipReplay = function () {
    "use strict";
    var self = this;
    if (this.initGameOver()) {
        return;
    }
    this.reinitializePowerUpUI();
    SoundManager.playEffect(SoundManager.UI_STATE.EXPLOSION, SoundManager.UICollection);
    new SkipReplayAnimation(function () {
        tgfAudio.stop("game");
        self.isShooting = false;
        self._showReplay = false;
        self.removeGame();
        self.addGame();
    });
};
PlayController.prototype.initGameOver = function () {
    "use strict";
    if (this.sharedData && this.sharedData["isGameOver"]) {
        this.sharedData["watchedFinalReplay"]++;
        this.showGameOver(this.isInitiatingPlayer);
        this.saveMatchData(false, "GAMEOVER");
        return true;
    }
    else {
        return false;
    }
};
var fbDebug = document.createElement("div");
fbDebug.added = false;
fbDebug.style.position = "absolute";
fbDebug.style.zIndex = 10000000;
fbDebug.style.font = "9px monospace";
fbDebug.style.background = "rgba(0, 0, 0, 1)";
fbDebug.style.color = "rgba(255, 255, 255, 1)";
fbDebug.style.padding = "0";
fbDebug.style.margin = "0";
fbDebug.style.whiteSpace = "pre";
fbDebug.style.borderRadius = "2px";
function customDebugMessage(str) {
    var t = document.createTextNode(str + " ");
    fbDebug.appendChild(t);
    if (!fbDebug.addded) {
        document.body.appendChild(fbDebug);
        var linebreak = document.createElement('br');
        fbDebug.appendChild(linebreak);
        fbDebug.added = true;
    }
}
PlayController.prototype.toggleInput = function (enable) {
    if (enable === undefined) {
        enable = !this.inputEnabled;
    }
    this.inputEnabled = enable;
    if (this.inputEnabled) {
        if (this.waitingScreen) {
            this.waitingScreen.dialog.activate();
        }
        if (this.replayController) {
            this.replayController.dialog.activate();
        }
        if (this.endScreen) {
            this.endScreen.dialog.activate();
        }
    }
    else {
        if (this.waitingScreen) {
            this.waitingScreen.dialog.deactivate();
        }
        if (this.replayController) {
            this.replayController.dialog.deactivate();
        }
        if (this.endScreen) {
            this.endScreen.dialog.deactivate();
        }
    }
    if (this.optionScreen) {
        this.optionScreen.toggleInput(enable);
    }
    if (this.uiController) {
        this.uiController.toggleInput(enable);
    }
};
PlayController.prototype.toggleSlingshotInput = function (enable) {
    "use strict";
    if (this.sceneController) {
        this.sceneController.setSlingshotInput(enable);
    }
};
PlayController.prototype.getRematchBtnText = function () {
    if (this.isAI) {
        if (this.isFake) {
            return tgfDictionary.getText("BTN_NEXT_MATCH");
        }
        else {
            return tgfDictionary.getText("BTN_REWARD_POPUP");
        }
    }
    else {
        return tgfDictionary.getText("BTN_REMATCH");
    }
};
PlayController.prototype.canRematch = function () {
    "use strict";
    if (this.isAI) {
        return this.isFake;
    }
    return (!this.isRandomOpponent && this.bothPlayersSawTheEndscreen);
};
PlayController.prototype.canAddScoreToLeaderboard = function () {
    "use strict";
    return false;
    return !(this.isAI && !this.isFake);
};
var regexThreeNumbers = /(\d+)(\d{3})/;
PlayController.prototype.beautifyScore = function (score) {
    var s = "" + Math.floor(score);
    while (regexThreeNumbers.test(s))
        s = s.replace(regexThreeNumbers, "$1" + "," + "$2");
    return s;
};
PlayController.prototype.openSettingsDialog = function () {
    var self = this;
    SoundManager.playEffect(SoundManager.UI_STATE.SELECT, SoundManager.UICollection, 0, false);
    // slingshot disable
    this.toggleSlingshotInput(false);
    this.optionScreen = new AngryOptionScreenDialog({
        optionSettings: ["music", "sfx", "tutorial", "lobby"],
        width: 800, height: 650,
        onClose: function () {
            self.toggleSlingshotInput(true);
        }
    });
    this.optionScreen.show();
    if (this.sceneController.usedPowerupThisTurn === false && this.waitingForPlayerWithoutDialog !== true) {
        this.uiController.cancelPowerup();
    }
};
PlayController.prototype.onLobbyButtonPressed = function () {
    this.messageHandler.hideAllMessages();
    AngryAnalytics.reportClickedLobbyDuringMatch();
    SoundManager.playEffect(SoundManager.UI_STATE.BACK, SoundManager.UICollection, 0, false);
    this.loader = new LoadingOverlay({
        x: tgfGraphics.areaWidth / 2,
        y: tgfGraphics.areaHeight / 2
    });
    gameController.stopPlay();
    tbGame.removeToken(this);
    this.waitingForPlayerWithoutDialog = false;
};
PlayController.prototype.showAdLoader = function () {
    this.loader.show();
};
PlayController.prototype.hideAdLoader = function () {
    this.loader.hide();
    this.loader.free();
    this.loader = undefined;
};
PlayController.prototype.handleFirstContact = function () {
    if (this.isAI && this.sceneController.state === SceneControllerState.REPLAYING && !AIController.isLastShot()) {
        this.isShooting = false;
        this.uiController.toggleShowUIButtons(false);
    }
};
